export default __webpack_public_path__ + "static/0092-a993d3a4af435bb358857eb5423cf27f.png";